import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import ReplayIcon from '@mui/icons-material/Replay';

interface RetryIconButtonProps {
  onRetry: (event: React.MouseEvent) => void;
}

function RetryIconButton(props: RetryIconButtonProps) {
  const { onRetry } = props;
  return (
    <Tooltip title="Retry">
      <IconButton onClick={onRetry}>
        <ReplayIcon />
      </IconButton>
    </Tooltip>
  );
}

export { RetryIconButton };
